module.exports = __webpack_public_path__ + "assets/01.7f056c47.pdf";